/* Pre-order notice - non-blocking.
   ------------------------------------------------------------------
   EDIT HERE: all customer-facing copy and the ship month.
   The product ID list lives in snippets/preorder-notice.liquid.
   ------------------------------------------------------------------ */
(function () {
  if (window.__preorderNoticeInit) return; // dedupe when several cards load the script
  window.__preorderNoticeInit = true;

  var CONFIG = {
    heading: 'Hi',
    /* %title% is replaced with the product title */
    intro: 'The %title% in %size% is currently out of stock but in production. It will be shipped in November.',
    label: 'You are aware that your order will be shipped in November.',
    cta: 'Tap to confirm',
    signatureSrc: 'https://cdn.shopify.com/s/files/1/0668/7791/5403/files/donce-full-signature.png',
    button: 'Continue',
    signDurationMs: 1400,           // how long the signature takes to write
    property: 'Pre-order',          // line item property name (shows in cart + admin)
    propertyValue: 'Ships in November'
  };

  /* variant id -> true when pre-order; merged from every map on the page */
  var MAP = {};
  var TITLES = {};
  var SIZES = {};
  function readMaps() {
    document.querySelectorAll('script[data-preorder-map]').forEach(function (el) {
      try {
        var data = JSON.parse(el.textContent);
        var title = el.getAttribute('data-preorder-title') || '';
        for (var k in data) {
          var v = data[k];
          if (v && typeof v === 'object') { MAP[k] = !!v.p; SIZES[k] = v.s || ''; }
          else { MAP[k] = !!v; }
          TITLES[k] = title;
        }
      } catch (e) { /* ignore malformed map */ }
    });
  }
  readMaps();

  /* ---------- signing dialog (portal at body level, no layout impact) ---------- */
  var root, lastFocus = null, signed = false;
  function buildDialog() {
    if (root) return root;
    root = document.createElement('div');
    root.className = 'preorder-notice';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', CONFIG.heading);
    root.innerHTML =
      '<div class="preorder-notice__underlay" data-pn-close></div>' +
      '<div class="preorder-notice__card">' +
        '<button type="button" class="preorder-notice__close" data-pn-close aria-label="Close">&#10005;</button>' +
        '<h2 class="preorder-notice__heading"></h2>' +
        '<p class="preorder-notice__intro"></p>' +
        '<p class="preorder-notice__label"></p>' +
        '<div class="preorder-notice__field" role="button" tabindex="0" data-pn-sign>' +
          '<span class="preorder-notice__cta"></span>' +
          '<span class="preorder-notice__x" aria-hidden="true">&#215;</span>' +
          '<span class="preorder-notice__baseline" aria-hidden="true"></span>' +
          '<span class="preorder-notice__sig"><img alt="" draggable="false"></span>' +
        '</div>' +
        '<button type="button" class="preorder-notice__button" disabled></button>' +
      '</div>';
    root.querySelector('.preorder-notice__heading').textContent = CONFIG.heading;
    root.querySelector('.preorder-notice__label').textContent = CONFIG.label;
    root.querySelector('.preorder-notice__cta').textContent = CONFIG.cta;
    root.querySelector('.preorder-notice__button').textContent = CONFIG.button;
    root.querySelector('.preorder-notice__sig img').src = CONFIG.signatureSrc;
    root.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-pn-close')) close();
    });
    var field = root.querySelector('[data-pn-sign]');
    field.addEventListener('click', sign);
    field.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); sign(); }
    });
    var btn = root.querySelector('.preorder-notice__button');
    btn.addEventListener('click', function () { if (signed) close(); });
    document.body.appendChild(root);
    return root;
  }
  function sign() {
    if (signed) return;
    signed = true;
    var field = root.querySelector('[data-pn-sign]');
    var sig = root.querySelector('.preorder-notice__sig');
    var img = sig.querySelector('img');
    field.classList.add('is-signed');
    /* whole signature must fit the field, smaller on phones */
    var full = Math.min(field.clientWidth - 64, 260);
    sig.style.setProperty('--sig-full', full + 'px');
    img.style.width = full + 'px';
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      sig.style.width = full + 'px';
      finishSign();
      return;
    }
    var start = null;
    function step(ts) {
      if (!start) start = ts;
      var t = Math.min(1, (ts - start) / CONFIG.signDurationMs);
      /* pen-like easing: quick start, settle, quick finish */
      var e = t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
      sig.style.width = (full * e) + 'px';
      if (t < 1) requestAnimationFrame(step);
      else finishSign();
    }
    requestAnimationFrame(step);
  }
  function finishSign() {
    var btn = root.querySelector('.preorder-notice__button');
    btn.disabled = false;
    btn.classList.add('is-active');
    btn.focus();
  }
  function open(variantId) {
    buildDialog();
    var title = (variantId && TITLES[variantId]) || 'item';
    var size = (variantId && SIZES[variantId]) || '';
    root.querySelector('.preorder-notice__intro').textContent =
      CONFIG.intro.replace('%title%', title).replace(' in %size%', size ? ' in ' + size : '');
    signed = false;
    root.querySelector('[data-pn-sign]').classList.remove('is-signed');
    root.querySelector('.preorder-notice__sig').style.width = '0px';
    var btn = root.querySelector('.preorder-notice__button');
    btn.disabled = true;
    btn.classList.remove('is-active');
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    root.querySelector('[data-pn-sign]').focus();
    document.addEventListener('keydown', onKey);
  }
  function close() {
    if (!root) return;
    root.classList.remove('is-open');
    document.removeEventListener('keydown', onKey);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function onKey(e) {
    if (e.key === 'Escape') close();
  }

  /* ---------- enrich the form, never block it ----------
     NOTE: the theme's [name=id] input sits OUTSIDE the <form> element
     (linked via the form="" attribute), so read it through form.elements. */
  function variantIdFromForm(form) {
    var el = form.elements && form.elements.namedItem ? form.elements.namedItem('id') : null;
    return el ? String(el.value) : null;
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    var id = variantIdFromForm(form);
    if (!id || !MAP[id]) return;
    if (!form.querySelector('[data-preorder-prop]')) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + CONFIG.property + ']';
      input.value = CONFIG.propertyValue;
      input.setAttribute('data-preorder-prop', '');
      form.appendChild(input);
    }
  }, true);

  /* ---------- watch /cart/add requests directly ----------
     Reads the variant id (and injects the property) from the request
     body itself, so it works for every add path - product form,
     sticky cart bar, quick-add - regardless of how the theme submits. */
  function idAndEnrich(body) {
    try {
      if (body instanceof FormData) {
        var id = body.get('id');
        if (id && MAP[String(id)] && !body.get('properties[' + CONFIG.property + ']')) {
          body.append('properties[' + CONFIG.property + ']', CONFIG.propertyValue);
        }
        return id ? String(id) : null;
      }
      if (body instanceof URLSearchParams) {
        var id2 = body.get('id');
        if (id2 && MAP[String(id2)]) body.append('properties[' + CONFIG.property + ']', CONFIG.propertyValue);
        return id2 ? String(id2) : null;
      }
      if (typeof body === 'string') {
        if (body.charAt(0) === '{') {
          var j = JSON.parse(body);
          var vid = j.id || (j.items && j.items[0] && j.items[0].id);
          return vid ? String(vid) : null; // JSON body is not mutated here
        }
        var m = /(?:^|&)id=(\d+)/.exec(body);
        return m ? m[1] : null;
      }
    } catch (e) { /* never break the add */ }
    return null;
  }
  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (url.indexOf('/cart/add') !== -1) {
      var id = init && init.body ? idAndEnrich(init.body) : null;
      var p = _fetch.apply(this, arguments);
      if (id && MAP[id]) {
        p.then(function (res) {
          if (res && res.ok) setTimeout(function(){ open(id); }, 150);
        }).catch(function () {});
      }
      return p;
    }
    return _fetch.apply(this, arguments);
  };

  /* XHR fallback for themes that do not use fetch */
  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__pnCartAdd = typeof url === 'string' && url.indexOf('/cart/add') !== -1;
    return _open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    if (this.__pnCartAdd) {
      var id = idAndEnrich(body);
      if (id && MAP[id]) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) setTimeout(function(){ open(id); }, 150);
        });
      }
    }
    return _send.apply(this, arguments);
  };
})();
